<template>
    <listPurchaseReconciliationComponent/>
</template>

<script>
import listPurchaseReconciliationComponent from "@/views/purchase_reconciliation/pages/list_purchase_reconciliation/components/list_purchase_reconciliation_component.vue"
export default {
    name: "ConciliationBuy",
    components: {
        listPurchaseReconciliationComponent
    },
}
</script>

<style lang="css" scoped>
</style>